import PropTypes from 'prop-types';
import React from 'react';


const MiniLinkButton = ({ className, href, target, child, handleOnClick }) => (
  <a className={ `mini-link-button ${className}` } href={ href } onClick={ handleOnClick } target={ target }>
    { child }
  </a>
);

MiniLinkButton.defaultProps = {
  child: '',
  className: '',
  handleOnClick: () => {},
  href: '',
  target: '_self',
};

MiniLinkButton.propTypes = {
  child: PropTypes.string,
  className: PropTypes.string,
  handleOnClick: PropTypes.func,
  href: PropTypes.string,
  target: PropTypes.string,
};

export default MiniLinkButton;
